import React from 'react';
import { Link } from 'react-router';
import SiteHead from './shared/components/header';

import './app.css';
import Footer from './shared/components/footer';

export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auditDropdownOpen: false
        };
        this.toggleAuditDropdown = this.toggleAuditDropdown.bind(this);
        this.closeAuditDropdown = this.closeAuditDropdown.bind(this);
        this.setDropdownRef = element => { this.dropdownRef = element; };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        if (this.dropdownRef && !this.dropdownRef.contains(e.target)) {
            this.closeAuditDropdown();
        }
    }

    toggleAuditDropdown() {
        this.setState({ auditDropdownOpen: !this.state.auditDropdownOpen });
    }

    closeAuditDropdown() {
        this.setState({ auditDropdownOpen: false });
    }

    render() {
        const isAuditActive = window.location.pathname === '/audit-register' || window.location.pathname === '/audit-tracking';
        
        return (
            <div className="app-wrapper">
                <SiteHead />
                
                {/* Horizontal Top Navigation */}
                <nav className="top-navigation">
                    <div className="nav-container">
                        <Link to="/questions" className="top-nav-item" activeClassName="active">
                            Questions
                        </Link>
                        <Link to="/reports" className="top-nav-item" activeClassName="active">
                            Reports
                        </Link>
                        <div className={"top-nav-dropdown" + (isAuditActive ? " active" : "")} ref={this.setDropdownRef}>
                            <button 
                                className={"top-nav-item dropdown-toggle" + (isAuditActive ? " active" : "")}
                                onClick={this.toggleAuditDropdown}
                            >
                                Audit Reports
                            </button>
                            {this.state.auditDropdownOpen && (
                                <div className="dropdown-menu-nav">
                                    <Link to="/audit-register" className="dropdown-item-nav" onClick={this.closeAuditDropdown}>
                                        Audit Register
                                    </Link>
                                    <Link to="/audit-tracking" className="dropdown-item-nav" onClick={this.closeAuditDropdown}>
                                        Audit Tracking
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </nav>

                <div className="content-container">
                    <div className="view">
                        {this.props.children}
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App.js